import { Component } from '@angular/core';

@Component({
  selector: 'tt-field-container',
  templateUrl: './field-container.component.html',
  styleUrls: ['./field-container.component.css']
})
export class FieldContainerComponent {

}
